var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 11.75C3.94727 11.75 0 15.6973 0 20.5625C0 23.3348 1.30352 25.9418 3.525 27.6125L43.475 57.575C45.568 59.1355 48.432 59.1355 50.525 57.575L90.475 27.6125C92.6965 25.9418 94 23.3348 94 20.5625C94 15.6973 90.0527 11.75 85.1875 11.75H8.8125ZM0 32.3125V70.5C0 76.9809 5.26914 82.25 11.75 82.25H82.25C88.7309 82.25 94 76.9809 94 70.5V32.3125L54.05 62.275C49.8641 65.4145 44.1359 65.4145 39.95 62.275L0 32.3125Z",
    fill: "#F2411F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3e743739ed737620a669da1d05f8f043.svg";
export { ForwardRef as ReactComponent };